<style lang="scss" scoped>
  @import '../../../sass/variables';

  .page-theme {
    margin-bottom: 0;
    border-radius: 0;
    min-height: 999px;
    background: $white-gray;
    border-top-left-radius: 20px;

    .categories {
      width: 280px;
      flex: 0 0 280px;
      padding-bottom: 30px;
    }

    .theme {
      min-height: 213px;
      position: relative;
      margin-bottom: 30px;
      justify-content: center;
      box-shadow: 0 5px 20px rgba(165, 131, 224, 0.15);

      &-starred {
        top: 0;
        right: 0;
        z-index: 9;
        width: 80px;
        height: 80px;
        position: absolute;
        border-top-right-radius: 15px;
        background-image: linear-gradient(to bottom left, #2CEBA9 0%, #2CEBA9 50%, transparent 50%, transparent);

        &-icon {
          top: 25px;
          right: 15px;
          width: 20px;
          height: 20px;
          display: flex;
          position: absolute;
          align-items: center;
          justify-content: center;
          transform: translateY(-50%);

          &--star {
            font-size: 20px;
            color: white !important;
          }
        }
      }

      &-thumb {
        padding: 24px;

        img {
          width: 100%;
          margin: 0 auto;
          display: block;
          border-radius: 5px;
        }
      }

      &-title {
        display: block;
        -webkit-margin-before: 25px;
        margin-block-start: 25px;
        -webkit-margin-after: 10px;
        margin-block-end: 10px;
        -webkit-margin-start: 0px;
        margin-inline-start: 0px;
        -webkit-margin-end: 0px;
        margin-inline-end: 0px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: -0.21px;
        line-height: 25px;
        text-align: center;
        -webkit-text-stroke: thin;
      }

      &:hover {
        .theme-blur,
        .theme-select {
          visibility: visible;
        }
      }
    }

    .thumbnail--blank {
      width: 53px !important;
      margin-top: 1rem !important;
    }

    .theme-blur {
      background: $white;
      opacity: 0.7;
    }

    .theme-blur,
    .theme-select {
      width: 100%;
      height: 100%;
      display: flex;
      position: absolute;
      align-items: center;
      border-radius: 15px;
      visibility: hidden;
      z-index: 9;

      &:hover {
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
      }
    }

    .theme-list {
      width: 100%;
    }
  }
</style>

<template>
  <div>
    <div class="row">
      <div class="col-12 d-flex align-items-center">
        <h2 class="page-subtitle">
          {{ page.title || 'LP sem título' }}
        </h2>
      </div>
    </div>
    <div class="page-theme board with-shadow d-flex">
      <div
        class="theme-list p-30px"
        v-show="! updating"
        item-selector=".theme"
      >
        <Masonry
          :cols="{ default: 4, 1366: 3, 1024: 2 }"
          gutter="25"
        >
          <div
            class="theme card pointer"
            v-for="template in templates"
            @click.prevent="changeTheme(template.id)"
            v-if="selectedCategory(template.category)"
          >
            <div class="theme-blur" />
            <div class="theme-select">
              <span class="btn btn-primary f-w-500 mx-auto">{{ __('Selecionar') }}</span>
            </div>
            <div class="theme-thumb">
              <img
                class="thumbnail thumbnail--blank"
                height="80px"
                src="/build/icons/file@2x.png"
                v-if="template.title === 'Em Branco' || template.thumbnail === null"
              ><img
                class="thumbnail"
                v-else
                :src="template.thumbnail"
              >
              <p
                class="theme-title"
                v-text="__(template.title)"
              />
            </div>
            <div
              class="theme-starred"
              v-if="template.title !== 'Em Branco' && template.thumbnail !== null"
            >
              <i
                class="theme-starred-icon"
                :class="['fa', 'fa-star text-danger', 'theme-starred-icon--star']"
              />
            </div>
          </div>
          <div
            class="theme card pointer"
            v-for="(theme, name) in sortedThemes"
            @click.prevent="changeTheme(name)"
            v-if="selectedCategory(theme.category)"
          >
            <div class="theme-blur" />
            <div class="theme-select">
              <span
                class="btn btn-primary f-w-500 mx-auto"
                v-if="! empty && current.page.theme == name"
              >{{ __('Selecionado') }}</span><span
                class="btn btn-primary f-w-500 mx-auto"
                v-else
              >{{ __('Selecionar') }}</span>
            </div>
            <div class="theme-thumb">
              <img
                class="thumbnail"
                :src="theme.thumbnail"
              >
              <p
                class="theme-title"
                v-text="__(theme.title)"
              />
            </div>
          </div>
        </Masonry>
      </div>
      <div class="categories ml-auto">
        <CategoryMenu
          :categories="categories"
          @update="(category) => this.current.category = category"
          scrollfix="scrollfix"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Confirm } from '../../services/Confirm';

export default {
  props: {
    page: {
      type: Object,
      required: true,
    },

    categories: {
      type: Object,
      required: true,
    },

    // New page, theme is not set yet
    empty: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      current: {
        page: this.page,
        category: 'all',
      },
      themes: [],
      templates: [],
      updating: true,
    };
  },

  computed: {
    sortedThemes () {
      return Object.keys(this.themes).sort().reduce((obj, theme) => {
        if (this.themes[theme].category == this.current.category || this.current.category == 'all') {
          obj[theme] = this.themes[theme];
        }

        return obj;
      }, {});
    },
  },

  mounted () {
    this.getThemes();
  },

  methods: {
    getThemes () {
      this.$http.get('/page/themes')
        .then(({ data }) => {
          this.themes = data.themes;
          this.templates = data.templates;
        })
        .then(() => this.updating = false)
        .catch((error) => console.log(error));
    },

    async changeTheme (theme) {
      const title = this.__('Confirme a troca de tema?');
      const text = this.__(' Atenção: você pode perder TODAS as suas alterações.');

      if (! this.empty && (
        theme === this.current.page.theme
            || ! await Confirm(title, text)
      )) {
        return;
      }

      this.updateTheme(theme);
    },

    updateTheme (theme) {
      this.$http.put(`/page/${this.page.id}`, { theme })
        .then(({ data }) => {
          window.location = `/page/${this.page.id}`;
        })
        .catch((error) => {
          console.log(error);

          Alert.error(this.__('Erro ao atualizar tema!'));
        });
    },

    hasThemeInCategory (category) {
      if (category == 'all') {
        return true;
      }

      return !! _.filter(this.themes, (theme) => theme.category == category).length;
    },

    selectedCategory (category) {
      if (this.current.category === 'all') {
        return true;
      }

      console.log(category);
      console.log(this.current.category);

      return category?.includes(this.current.category);
    },
  },
};
</script>
